export const TransmissionType = {
  None: 0,
  Manual: 1,
  Auto: 2,
}

export const TransmissionTypes = [
  { label: 'Manual', value: TransmissionType.Manual },
  { label: 'Auto', value: TransmissionType.Auto },
]

export const NormalizedTransmissionTypes = {
  1: 'Manual',
  2: 'Auto',
}
